import script from "./IncomeDescriber.vue?vue&type=script&setup=true&lang=ts"
export * from "./IncomeDescriber.vue?vue&type=script&setup=true&lang=ts"

import "./IncomeDescriber.vue?vue&type=style&index=0&id=869e02a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-869e02a0"]])

export default __exports__